import React from 'react';
import { ISelectOption } from '../../../domain/saved-filters/interface';
import { BaseFilterCheckboxSelect } from '../base/BaseFilterCheckboxSelect';

interface IPjmLocationZipCodeFilterSelectProps {
    value: string[];
    onChange: (value: string[]) => void;
    label?: string;
    height?: number;
    searchable?: boolean;
    disabled?: boolean;
    resizable?: boolean;
    options: ISelectOption<string>[];
    isLoading?: boolean;
}

export const PjmLocationZipCodeFilterSelect: React.FC<IPjmLocationZipCodeFilterSelectProps> = ({
    value,
    onChange,
    label,
    height = 300,
    disabled = false,
    options,
    isLoading,
}) => {
    return (
        <BaseFilterCheckboxSelect
            multiple
            resizable
            searchable={true}
            showSelectAllOption={false}
            selectedCountInLabel
            disabled={disabled}
            options={options}
            value={value}
            onChange={onChange}
            loading={isLoading}
            label={label}
            height={height}
        />
    );
};
